import styled from '@emotion/styled'

export const StyledAssetTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  td,
  th {
    padding: 12px;
  }

  th {
    background-color: var(--Transparent);
    font-weight: normal;
    text-align: left;
  }

  tbody {
    background-color: var(--White96);
  }

  td {
    border: 2px solid var(--White);
  }

  tr:first-of-type td {
    border-top: 0;
  }

  .asset {
    border-left: 0;
    border-right: 0;
    width: 50%;
    text-align: left;
    button {
      text-align: left;
    }
  }

  .return {
    border-left: 0;
    border-right: 0;
    text-align: right;
  }

  .volatility {
    border-left: 0;
    text-align: right;
  }

  .weight {
    border-right: 0;
    text-align: right;
  }

  .investment {
    border-right: 0;
    text-align: right;
  }

  td.asset {
    border-left: 0;
    border-right: 0;
    width: 50%;
  }

  td.return {
    border-left: 0;
    border-right: 0;
  }

  td.volatility {
    border-left: 0;
  }

  td.weight {
    border-right: 0;
  }

  td.investment {
    border-right: 0;
  }

  tr:last-child td {
    border-bottom: 0;
  }
`
